const PixelIndex = () => import('@/modules/pixels/views/PixelIndex')

export default [
  {
    path: '/pixels',
    name: 'pixels.index',
    component: PixelIndex,
    meta: { requiresAuthentication: true }
  }
]
